/** Backend connector display name (must match workspace connector configuration). */
export const EMAIL_CONNECTOR_NAME = 'Mailtrap Connector';

/** Authenticated email connectors accepted for the channel (Mailtrap preferred via array order). */
export const EMAIL_CONNECTOR_NAMES = [EMAIL_CONNECTOR_NAME, 'Mail'] as const;

/** Connector flow names (must match workspace connector flow configuration). */
export const EMAIL_CONNECTOR_FLOW_NAME = 'Mailtrap Send Flow';
export const EMAIL_TEMPLATE_CONNECTOR_FLOW_NAME = 'Mailtrap Template Insert Flow';
export const EMAIL_TEMPLATE_EDIT_FLOW_NAME = 'Mailtrap Template Edit Flow';
export const EMAIL_TEMPLATE_DELETE_FLOW_NAME = 'Mailtrap Template Delete Flow';
export const EMAIL_DOMAIN_INSERT_FLOW_NAME = 'Mailtrap Domain Insert Flow';
export const EMAIL_DOMAIN_INFO_FLOW_NAME = 'Mailtrap Domain Info Flow';
export const EMAIL_DOMAIN_DELETE_FLOW_NAME = 'Mailtrap Domain Delete Flow';
export const EMAIL_CONNECTOR_NAME_KEYWORD = 'mail';

/**
 * Names of the flow serving each role on the email connector.
 * Lookups are always scoped to the authenticated email connector id — never by name alone.
 * Short aliases cover rows seeded after the Mailtrap long names were shortened.
 */
export const EMAIL_FLOW_NAMES = {
  send: [EMAIL_CONNECTOR_FLOW_NAME, 'Send'],
  templateInsert: [EMAIL_TEMPLATE_CONNECTOR_FLOW_NAME, 'Insert Template'],
  templateEdit: [EMAIL_TEMPLATE_EDIT_FLOW_NAME, 'Edit Template'],
  templateDelete: [EMAIL_TEMPLATE_DELETE_FLOW_NAME, 'Delete Template'],
  domainInsert: [EMAIL_DOMAIN_INSERT_FLOW_NAME, 'Domain Insert'],
  domainInfo: [EMAIL_DOMAIN_INFO_FLOW_NAME, 'Domain Info'],
  domainDelete: [EMAIL_DOMAIN_DELETE_FLOW_NAME, 'Domain Delete'],
} as const;

export type EmailFlowRole = keyof typeof EMAIL_FLOW_NAMES;
